import { Translate } from "./Tranlate";

let lang = localStorage.getItem("padelinkLang") || "en";
export const months = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
];
export const daysOptions = ["SAT", "SUN", "MON", "TUE", "WED", "THU", "FRI"];
export const daysValuesOptions = [
	{ label: "Saturday", value: "SAT" },
	{ label: "Sunday", value: "SUN" },
	{ label: "Monday", value: "MON" },
	{ label: "Tuesday", value: "TUE" },
	{ label: "Wednesday", value: "WED" },
	{ label: "Thursday", value: "THU" },
	{ label: "Friday", value: "FRI" },
];

export const AcceptedYearsOptions = Array.from(
	{ length: 2031 - 2000 },
	(_, i) => {
		const year = 2000 + i;
		return { label: year.toString(), value: year };
	}
);

export const degreeOptions = [
	{ label: Translate[lang].bachelors, value: "BACHELORS" },
	{ label: Translate[lang].master, value: "MASTERS" },
	{ label: Translate[lang].phd, value: "PHD" },
	{ label: Translate[lang].diploma, value: "DIPLOMA" },
	{ label: Translate[lang].high_school, value: "HIGH_SCHOOL" },
	{ label: Translate[lang].associate, value: "ASSOCIATE" },
	{ label: Translate[lang].other, value: "OTHER" },
];

export const convertDate = (date) =>
	new Date(`${date}T00:00:00Z`).toISOString();

export const matchesTypes = [
	{
		label: "public",
		icon: (
			<svg
				width="16"
				height="20"
				viewBox="0 0 16 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M13.625 19.375H2.375C1.87772 19.375 1.40081 19.1775 1.04917 18.8258C0.697544 18.4742 0.5 17.9973 0.5 17.5V10.625C0.5 10.1277 0.697544 9.65081 1.04917 9.29917C1.40081 8.94754 1.87772 8.75 2.375 8.75H13.625C14.1223 8.75 14.5992 8.94754 14.9508 9.29917C15.3025 9.65081 15.5 10.1277 15.5 10.625V17.5C15.5 17.9973 15.3025 18.4742 14.9508 18.8258C14.5992 19.1775 14.1223 19.375 13.625 19.375ZM2.375 10C2.20924 10 2.05027 10.0658 1.93306 10.1831C1.81585 10.3003 1.75 10.4592 1.75 10.625V17.5C1.75 17.6658 1.81585 17.8247 1.93306 17.9419C2.05027 18.0592 2.20924 18.125 2.375 18.125H13.625C13.7908 18.125 13.9497 18.0592 14.0669 17.9419C14.1842 17.8247 14.25 17.6658 14.25 17.5V10.625C14.25 10.4592 14.1842 10.3003 14.0669 10.1831C13.9497 10.0658 13.7908 10 13.625 10H2.375Z"
					fill="black"
				/>
				<path
					d="M3 10C2.83424 10 2.67527 9.93415 2.55806 9.81694C2.44085 9.69973 2.375 9.54076 2.375 9.375V5.625C2.375 4.29892 2.90178 3.02715 3.83947 2.08947C4.77715 1.15178 6.04892 0.625 7.375 0.625H8.625C9.95108 0.625 11.2229 1.15178 12.1605 2.08947C13.0982 3.02715 13.625 4.29892 13.625 5.625C13.625 5.79076 13.5592 5.94973 13.4419 6.06694C13.3247 6.18415 13.1658 6.25 13 6.25C12.8342 6.25 12.6753 6.18415 12.5581 6.06694C12.4408 5.94973 12.375 5.79076 12.375 5.625C12.375 4.63044 11.9799 3.67661 11.2767 2.97335C10.5734 2.27009 9.61956 1.875 8.625 1.875H7.375C6.38044 1.875 5.42661 2.27009 4.72335 2.97335C4.02009 3.67661 3.625 4.63044 3.625 5.625V9.375C3.625 9.54076 3.55915 9.69973 3.44194 9.81694C3.32473 9.93415 3.16576 10 3 10Z"
					fill="black"
				/>
				<path
					d="M8 14.375C7.75277 14.375 7.5111 14.3017 7.30554 14.1643C7.09998 14.027 6.93976 13.8318 6.84515 13.6034C6.75054 13.3749 6.72579 13.1236 6.77402 12.8811C6.82225 12.6387 6.9413 12.4159 7.11612 12.2411C7.29093 12.0663 7.51366 11.9473 7.75614 11.899C7.99861 11.8508 8.24995 11.8755 8.47836 11.9702C8.70676 12.0648 8.90199 12.225 9.03934 12.4305C9.17669 12.6361 9.25 12.8778 9.25 13.125C9.25 13.4565 9.1183 13.7745 8.88388 14.0089C8.64946 14.2433 8.33152 14.375 8 14.375Z"
					fill="black"
				/>
				<path d="M8.625 13.75H7.375V16.25H8.625V13.75Z" fill="black" />
			</svg>
		),
	},
	{
		label: "private",
		icon: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M15.625 19.375H4.375C3.87772 19.375 3.40081 19.1775 3.04917 18.8258C2.69754 18.4742 2.5 17.9973 2.5 17.5V10.625C2.5 10.1277 2.69754 9.65081 3.04917 9.29917C3.40081 8.94754 3.87772 8.75 4.375 8.75H15.625C16.1223 8.75 16.5992 8.94754 16.9508 9.29917C17.3025 9.65081 17.5 10.1277 17.5 10.625V17.5C17.5 17.9973 17.3025 18.4742 16.9508 18.8258C16.5992 19.1775 16.1223 19.375 15.625 19.375ZM4.375 10C4.20924 10 4.05027 10.0658 3.93306 10.1831C3.81585 10.3003 3.75 10.4592 3.75 10.625V17.5C3.75 17.6658 3.81585 17.8247 3.93306 17.9419C4.05027 18.0592 4.20924 18.125 4.375 18.125H15.625C15.7908 18.125 15.9497 18.0592 16.0669 17.9419C16.1842 17.8247 16.25 17.6658 16.25 17.5V10.625C16.25 10.4592 16.1842 10.3003 16.0669 10.1831C15.9497 10.0658 15.7908 10 15.625 10H4.375Z"
					fill="black"
				/>
				<path
					d="M15 10H5C4.83424 10 4.67527 9.93415 4.55806 9.81694C4.44085 9.69973 4.375 9.54076 4.375 9.375V5.625C4.375 4.29892 4.90178 3.02715 5.83947 2.08947C6.77715 1.15178 8.04892 0.625 9.375 0.625H10.625C11.9511 0.625 13.2229 1.15178 14.1605 2.08947C15.0982 3.02715 15.625 4.29892 15.625 5.625V9.375C15.625 9.54076 15.5592 9.69973 15.4419 9.81694C15.3247 9.93415 15.1658 10 15 10ZM5.625 8.75H14.375V5.625C14.375 4.63044 13.9799 3.67661 13.2767 2.97335C12.5734 2.27009 11.6196 1.875 10.625 1.875H9.375C8.38044 1.875 7.42661 2.27009 6.72335 2.97335C6.02009 3.67661 5.625 4.63044 5.625 5.625V8.75Z"
					fill="black"
				/>
				<path
					d="M10 14.375C9.75277 14.375 9.5111 14.3017 9.30554 14.1643C9.09998 14.027 8.93976 13.8318 8.84515 13.6034C8.75054 13.3749 8.72579 13.1236 8.77402 12.8811C8.82225 12.6387 8.9413 12.4159 9.11612 12.2411C9.29093 12.0663 9.51366 11.9473 9.75614 11.899C9.99861 11.8508 10.2499 11.8755 10.4784 11.9702C10.7068 12.0648 10.902 12.225 11.0393 12.4305C11.1767 12.6361 11.25 12.8778 11.25 13.125C11.25 13.4565 11.1183 13.7745 10.8839 14.0089C10.6495 14.2433 10.3315 14.375 10 14.375Z"
					fill="black"
				/>
				<path d="M10.625 13.75H9.375V16.25H10.625V13.75Z" fill="black" />
			</svg>
		),
	},
	{
		label: "tournament",
		icon: (
			<svg
				width="15"
				height="17"
				viewBox="0 0 15 17"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M11.7424 6.06061C11.7424 8.17804 10.2928 9.95153 8.33334 10.4568V14.394H10.6061C10.8155 14.394 10.9849 14.5637 10.9849 14.7727C10.9849 14.9822 10.8155 15.1515 10.6061 15.1515H3.78788C3.57841 15.1515 3.4091 14.9822 3.4091 14.7727C3.4091 14.5637 3.57841 14.394 3.78788 14.394H6.06061V10.4568C4.10114 9.95153 2.65152 8.17804 2.65152 6.06061C1.18712 6.06061 0 4.87349 0 3.4091V2.65152C0 2.44243 0.169318 2.27273 0.378788 2.27273H2.65152V1.89394C2.65152 1.26629 2.14281 0.757577 1.51515 0.757577C1.30568 0.757577 1.13637 0.58788 1.13637 0.378788C1.13637 0.169697 1.30568 0 1.51515 0H12.8788C13.0883 0 13.2576 0.169697 13.2576 0.378788C13.2576 0.58788 13.0883 0.757577 12.8788 0.757577C12.2512 0.757577 11.7424 1.26629 11.7424 1.89394V2.27273H14.0152C14.2246 2.27273 14.394 2.44243 14.394 2.65152V3.4091C14.394 4.87349 13.2068 6.06061 11.7424 6.06061ZM6.81819 14.394H7.57577V10.5868C7.45077 10.5974 7.32501 10.6061 7.19698 10.6061C7.06895 10.6061 6.94319 10.5974 6.81819 10.5868V14.394ZM0.757577 3.03031V3.4091C0.757577 4.45531 1.60531 5.30304 2.65152 5.30304V3.03031H0.757577ZM3.02197 0.757577C3.26137 1.075 3.4091 1.46553 3.4091 1.89394V6.06061C3.4091 8.15266 5.10493 9.8485 7.19698 9.8485C9.28865 9.8485 10.9849 8.15266 10.9849 6.06061V1.89394C10.9849 1.46553 11.1326 1.075 11.372 0.757577H3.02197ZM13.6364 3.03031H11.7424V5.30304C12.7887 5.30304 13.6364 4.45531 13.6364 3.4091V3.03031ZM2.65152 15.9091H11.7424C11.9519 15.9091 12.1212 16.0788 12.1212 16.2879C12.1212 16.4974 11.9519 16.6667 11.7424 16.6667H2.65152C2.44205 16.6667 2.27273 16.4974 2.27273 16.2879C2.27273 16.0788 2.44205 15.9091 2.65152 15.9091Z"
					fill="black"
				/>
			</svg>
		),
	},
];
export const times = [
	"09:00 AM",
	"10:00 AM",
	"11:00 AM",
	"12:00 PM",
	"01:00 PM",
	"02:00 PM",
];
export const duration_of_the_match = ["60 min", "90 min", "120 min"];
